import { useState } from "react";
import { X, Lock } from "lucide-react";
import api from "../../services/api";

export default function BlockRoomModal({ onClose, onSave }) {
  var startState = useState("");
  var endState = useState("");
  var reasonState = useState("");
  var loadingState = useState(false);
  var errorState = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!startState[0] || !reasonState[0].trim()) return;
    loadingState[1](true);
    errorState[1](null);
    try {
      await api.post("/room/blocks", {
        start_date: startState[0],
        end_date: endState[0] || startState[0],
        reason: reasonState[0].trim(),
      });
      onSave();
    } catch (err) {
      var d = err.response ? err.response.data : null;
      var detail = d ? d.detail : "Erro ao bloquear sala";
      errorState[1](typeof detail === "string" ? detail : "Erro ao bloquear sala");
    } finally {
      loadingState[1](false);
    }
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed bottom-0 left-0 right-0 sm:bottom-auto sm:top-1/2 sm:left-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 z-50 sm:max-w-md sm:w-full" data-testid="block-room-modal">
        <div className="bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <div className="p-2 bg-red-100 rounded-lg"><Lock className="w-5 h-5 text-red-600" /></div>
              <h2 className="text-lg font-bold text-[#0A2F3D]">Bloquear Sala</h2>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          {errorState[0] && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Data Inicio *</label>
                <input type="date" value={startState[0]} onChange={function (e) { startState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-red-500/30"
                  required data-testid="block-form-start" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Data Fim</label>
                <input type="date" value={endState[0]} onChange={function (e) { endState[1](e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-red-500/30"
                  data-testid="block-form-end" />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Motivo *</label>
              <input type="text" value={reasonState[0]} onChange={function (e) { reasonState[1](e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-red-500/30"
                placeholder="Ex: Treinamento interno, Evento especial..." required data-testid="block-form-reason" />
            </div>
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loadingState[0]}
                className="flex-1 px-4 py-2.5 bg-red-500 text-white rounded-xl text-sm font-medium hover:bg-red-600 disabled:opacity-50" data-testid="block-form-submit">
                {loadingState[0] ? "Bloqueando..." : "Bloquear Sala"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
